var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"backButton"}},[_c('font-awesome-icon',{staticClass:"back-btn",attrs:{"icon":"arrow-left"},on:{"click":function($event){return _vm.back()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }